import { Component } from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OpportunitySecurityChecklistService from '../../../Services/opportunitySecurityChecklistService';
import OpportunitySecurityChecklistItem from '../../../Domain/OpportunitySecurityChecklistItem';

export default class EditOpportunitySecurityChecklistWindowDescription extends Component {
  static titleForCreate = 'Add New Opportunity Security Checklist';
  static titleForEdit = 'Edit Opportunity Security Checklist';
  static ComponentName = 'Opportunity Security Checklist';

  static itemType = OpportunitySecurityChecklistItem;
  static serviceFunction = (edited) => OpportunitySecurityChecklistService.UpsertChecklist(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'Contacts',
      fields: [
        {
          fieldName: 'ContactName',
          label: 'InfoSec and Privacy Contact Name',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ContactEmail',
          label: 'InfoSec and Privacy Contact Email',
          type: InputTypesEnum.Email,
          validityChecker: ValidityHelper.forEmailRequired,
        },
        {
          fieldName: 'ContactPhone',
          label: 'InfoSec and Privacy Contact Phone',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.forRequiredPhoneNumber,
        },
        {
          fieldName: 'AuthorizedClientBusinessRep',
          label: 'Authorized Client Business Representative',
          type: InputTypesEnum.ContactMultiChoice,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ApprovedLogoUsage',
          label: 'Client Logo Usage Approved?',
          type: InputTypesEnum.Select,
          selectvalues: EditOpportunitySecurityChecklistWindowDescription.getClientApprovedValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ApprovedNameUsage',
          label: 'Client Name Usage Approved?',
          type: InputTypesEnum.Select,
          selectvalues: EditOpportunitySecurityChecklistWindowDescription.getClientApprovedValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'SLA & Storage',
      fields: [
        {
          fieldName: 'SecurityIncidentNotification',
          label: 'Data Security Incident Notification (hours)',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'PrivacyBreachNotification',
          label: 'Data Privacy Breach Notification (hours)',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'SubjectInquiryNotification',
          label: 'Data Subject Inquiry Notification (working days)',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'ErasureNotification',
          label: 'Data Erasure Notification (working days)',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'DataFlowMap',
          label: 'Data Storage Location',
          type: InputTypesEnum.DataFlowMapMultiChoice,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'DataFlowMapFreeText',
          label: 'Data Storage Location Details',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            item.DataFlowMap == undefined ||
            item.DataFlowMap.length == 0 ||
            !item.DataFlowMap.some((dfm) => dfm === 'Other'),
        },
      ],
    },
    {
      label: 'Data Management',
      fields: [
        {
          fieldName: 'ClientAccountContactsData',
          label: 'Client Account Contacts Personal Data (month(s))',
          type: InputTypesEnum.Text,
          validityChecker: EditOpportunitySecurityChecklistWindowDescription.clientAccountContactsDataValidityChecker,
        },
        {
          fieldName: 'ClientOperationalContactsData',
          label: 'Client Operational Contacts Personal Data (month(s))',
          type: InputTypesEnum.Text,
          validityChecker:
            EditOpportunitySecurityChecklistWindowDescription.clientOperationalContactsDataValidityChecker,
        },
        {
          fieldName: 'DeliveredEvaluationDetails',
          label: 'Delivered Evaluation Details (month(s))',
          type: InputTypesEnum.Text,
          validityChecker: EditOpportunitySecurityChecklistWindowDescription.deliveredEvaluationDetailsValidityChecker,
        },
        {
          fieldName: 'ClientOperationalContactsExport',
          label: 'Export Client operational contacts at termination?',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          fieldName: 'DeliveredEvaluationDetailsExport',
          label: 'Export evaluation details at termination?',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          fieldName: 'PublicInformationClassification',
          label: 'Public',
          type: InputTypesEnum.Text,
          numberOfRows: 2,
          validityChecker: ValidityHelper.emptyValidityChecker,
          tooltipText:
            'Available to any member of the public without restriction. This information however should not be placed into the public domain without reason, such as a request or publishing as part of data management policy.',
          placeholder:
            'Available to any member of the public without restriction. This information however should not be placed into the public domain without reason, such as a request or publishing as part of data management policy.',
        },
        {
          fieldName: 'InternalInformationClassification',
          label: 'Internal',
          type: InputTypesEnum.Text,
          numberOfRows: 2,
          validityChecker: ValidityHelper.emptyValidityChecker,
          tooltipText:
            'Available to any authenticated member of BARE International. Typically, if this level of information was leaked outside of BARE International, it could be inappropriate or ill-timed.',
          placeholder:
            'Available to any authenticated member of BARE International. Typically, if this level of information was leaked outside of BARE International, it could be inappropriate or ill-timed.',
        },
        {
          fieldName: 'RestrictedInformationClassification',
          label: 'Restricted',
          type: InputTypesEnum.Text,
          numberOfRows: 2,
          validityChecker: ValidityHelper.emptyValidityChecker,
          tooltipText:
            'Available only to specified and relevant members, with appropriate authorization. A breach of confidentiality could result in unacceptable damage with very serious and lasting consequences threatening BARE International or one of its activities.',
          placeholder: EditOpportunitySecurityChecklistWindowDescription.getRestrictedPlaceholder,
        },
        {
          fieldName: 'ConfidentialInformationClassification',
          label: 'Confidential',
          type: InputTypesEnum.Text,
          numberOfRows: 2,
          validityChecker: ValidityHelper.emptyValidityChecker,
          tooltipText:
            'Available only to specified and / or relevant members, with appropriate authorization. A breach of confidentiality could cause serious damage resulting in the compromise of activity within BARE International in the short to medium term. This includes both personnel data and research data.',
          placeholder:
            'Available only to specified and / or relevant members, with appropriate authorization. A breach of confidentiality could cause serious damage resulting in the compromise of activity within BARE International in the short to medium term. This includes both personnel data and research data.',
        },
      ],
    },
  ];

  static getRestrictedPlaceholder() {
    return 'Available only to specified and relevant members, with appropriate authorization. A breach of confidentiality could result in unacceptable damage with very serious and lasting consequences threatening BARE International or one of its activities.';
  }

  static clientOperationalContactsDataValidityChecker(value, item) {
    return EditOpportunitySecurityChecklistWindowDescription.civilLimitationValidityChecker(
      value,
      item.ClientOperationalContactsData
    );
  }

  static clientAccountContactsDataValidityChecker(value, item) {
    return EditOpportunitySecurityChecklistWindowDescription.civilLimitationValidityChecker(
      value,
      item.ClientAccountContactsData
    );
  }

  static civilLimitationValidityChecker(value, field) {
    if (!value || value.trim() === '') return "This field can't be empty.";
    if (
      field !== 'according to the civil limitation period for a particular contract' &&
      (isNaN(value) || ValidityHelper.forRequiredNumberFieldGreaterThanZero(value) !== '')
    ) {
      return "Text should be 'according to the civil limitation period for a particular contract'; or a number that is more than 0";
    }
    return '';
  }

  static deliveredEvaluationDetailsValidityChecker(value, item) {
    if (!value || value.trim() === '') return "This field can't be empty.";
    if (
      item.DeliveredEvaluationDetails !== 'indefinite in an anonymized format' &&
      (isNaN(item.DeliveredEvaluationDetails) ||
        ValidityHelper.forRequiredNumberFieldGreaterThanZero(item.DeliveredEvaluationDetails) !== '')
    ) {
      return "Text should be 'indefinite in an anonymized format'; or a number that is more than 0";
    }
    return '';
  }

  static getClientApprovedValues(editedItem) {
    return [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
      { label: 'On Client Approval', value: 'On Client Approval' },
    ];
  }
}
